import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=dd8ef52e&scoped=true&"
import script from "./BarChart.ts?vue&type=script&lang=ts&"
export * from "./BarChart.ts?vue&type=script&lang=ts&"
import style0 from "./Barchart.scss?vue&type=style&index=0&id=dd8ef52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8ef52e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
